import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { getLoginRequest } from "@/config/msalConfig";

/**
 * Guard that redirects unauthenticated users to Entra. Anyone arriving
 * with a deep link (e.g. /myapps/tokens) has that URL stashed in
 * sessionStorage so AuthCallbackPage can restore it after redirect.
 */
export function ProtectedRoute() {
  const { instance, accounts, inProgress } = useMsal();
  const location = useLocation();

  const isAuthenticated =
    !!instance.getActiveAccount() || accounts.length > 0;

  useEffect(() => {
    if (isAuthenticated) return;
    if (inProgress !== "none") return;

    try {
      const returnTo = location.pathname + location.search + location.hash;
      sessionStorage.setItem("portal:returnTo", returnTo);
    } catch {
      /* noop */
    }

    instance.loginRedirect(getLoginRequest()).catch((err) => {
      console.error("[auth] loginRedirect failed", err);
    });
  }, [instance, inProgress, isAuthenticated, location]);

  if (!isAuthenticated) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center text-sm text-slate-500">
        Redirecting to sign-in…
      </div>
    );
  }

  return <Outlet />;
}
